import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="text-center">
            <img src="/24lp-logo-white.png" alt="24 Capital Partners" className="h-24 w-auto mb-4 mx-auto" />
            <p className="text-gray-400 max-w-md mx-auto">
              Twenty Four Capital Partners provides innovative equity financing solutions for public companies, 
              offering flexible capital without dilution or restrictive covenants.
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Resources</h4>
            <ul className="space-y-2">
              <li><Link to="/check-eligibility" className="text-gray-400 hover:text-white">Check Eligibility</Link></li>
              <li><Link to="/blog" className="text-gray-400 hover:text-white">Blog</Link></li>
              <li><Link to="/glossary" className="text-gray-400 hover:text-white">Glossary</Link></li>
              <li><Link to="/faq" className="text-gray-400 hover:text-white">FAQ</Link></li>
              <li><a href="/#how-it-works" className="text-gray-400 hover:text-white">How it Works</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              <li><Link to="/contact" className="text-gray-400 hover:text-white">Contact</Link></li>
              <li><Link to="/careers" className="text-gray-400 hover:text-white">Careers</Link></li>
              <li><Link to="/social-impact" className="text-gray-400 hover:text-white">Social Impact</Link></li>
              <li><Link to="/broker/register" className="text-gray-400 hover:text-white">Partner Signup</Link></li>
              <li><Link to="/customer-service" className="text-gray-400 hover:text-white">Customer Service</Link></li>
              <li><Link to="/login" className="text-gray-400 hover:text-white">Login</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Legal</h4>
            <ul className="space-y-2">
              <li><Link to="/legal/terms" className="text-gray-400 hover:text-white">Terms of Service</Link></li>
              <li><Link to="/legal/privacy" className="text-gray-400 hover:text-white">Privacy Policy</Link></li>
              <li><Link to="/legal/cookies" className="text-gray-400 hover:text-white">Cookie Policy</Link></li>
              <li><Link to="/legal/disclaimer" className="text-gray-400 hover:text-white">Disclaimer</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2025 Twenty Four Capital LLC. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 